var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M569.231-192.307v-29.231q0-13.265 5.346-25.287 5.346-12.021 14.038-20.713l193.923-193.154q5.924-5.154 12.223-7.616 6.299-2.461 12.598-2.461 6.872 0 13.505 2.577 6.632 2.577 12.059 7.73l37 37.77q4.923 5.923 7.5 12.307Q880-404 880-397.615q0 6.384-2.077 12.884t-8 12.424L676.769-179.154q-8.692 8.693-20.713 13.923Q644.034-160 630.769-160h-29.231q-13.73 0-23.019-9.288-9.288-9.289-9.288-23.019ZM200-247.692v-33.539q0-24.769 14.423-46.346 14.423-21.577 38.808-33.5 56.615-27.154 113.307-40.731Q423.231-415.385 480-415.385q27 0 54.154 3.346 27.154 3.347 54.692 9.5l-86.154 86.154q-14.011 13.77-21.428 31.589-7.418 17.819-7.418 37.258v32.154H232.307q-13.73 0-23.019-9.289Q200-233.961 200-247.692Zm607.615-111.693 37-38.23-37-37.77-38 38 38 38ZM480-504.615q-49.5 0-84.75-35.25T360-624.615q0-49.501 35.25-84.751 35.25-35.25 84.75-35.25t84.75 35.25Q600-674.116 600-624.615q0 49.5-35.25 84.75T480-504.615Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUser);
export default __webpack_public_path__ + "static/media/editUser.df48c74be5f330a6b4570f33327dcabc.svg";
export { ForwardRef as ReactComponent };